import { clsx } from 'clsx'
import { Mark } from './logo'

function Row({ children }) {
  return (
    <div className="group relative">
      <div className="absolute inset-x-0 top-1/2 h-0.5 bg-linear-to-r from-gray-300 from-[2px] to-[2px] bg-[length:12px_100%]" />
      <div className="absolute inset-x-0 top-1/2 h-0.5 bg-linear-to-r from-white/15 from-[2px] to-[2px] bg-[length:12px_100%]" />
      <div className="absolute inset-x-0 bottom-0 h-0.5 bg-linear-to-r from-white/5 from-[2px] to-[2px] bg-[length:12px_100%] group-last:hidden" />
      {children}
    </div>
  )
}

function Logo({
  label,
  src,
  className,
}) {
  return (
    <div
      className={clsx(
        className,
        'absolute top-2 grid grid-cols-[1rem_1fr] items-center gap-2 px-3 py-1 whitespace-nowrap',
        'rounded-full bg-linear-to-t from-gray-800 from-50% to-gray-700 ring-1 ring-white/10 ring-inset',
        '[--move-x-from:-100%] [--move-x-to:calc(100%+100cqw)] [animation-iteration-count:infinite] [animation-name:move-x] [animation-play-state:paused] [animation-timing-function:linear] group-hover:[animation-play-state:running]',
      )}
    >
      <img alt="" src={src} className="size-4" />
      <span className="text-sm/6 font-medium text-white">{label}</span>
    </div>
  )
}

export function LogoTimelineTech() {
  return (
    <div aria-hidden="true" className="relative h-full overflow-hidden">
      <div className="[container-type:inline-size] absolute inset-0 grid grid-cols-1 pt-8">
        <Row>
          <Logo
            label="Auth0"
            src="/assets/auth0.svg"
            className="[animation-delay:-26s] [animation-duration:30s]"
          />
          <Logo
            label="Django"
            src="/assets/django.svg"
            className="[animation-delay:-8s] [animation-duration:30s]"
          />
        </Row>
        <Row>
          <Logo
            label="Docker"
            src="/assets/docker.svg"
            className="[animation-delay:-40s] [animation-duration:40s]"
          />
          <Logo
            label="FastAPI"
            src="/assets/fastapi.svg"
            className="[animation-delay:-20s] [animation-duration:40s]"
          />
        </Row>
        <Row>
          <Logo
            label="Firebase"
            src="/assets/firebase.svg"
            className="[animation-delay:-10s] [animation-duration:40s]"
          />
          <Logo
            label="GraphQL"
            src="/assets/graphql.svg"
            className="[animation-delay:-32s] [animation-duration:40s]"
          />
        </Row>
        <Row>
          <Logo
            label="Kafka"
            src="/assets/kafka.svg"
            className="[animation-delay:-45s] [animation-duration:45s]"
          />
          <Logo
            label="MongoDB"
            src="/assets/mongodb.svg"
            className="[animation-delay:-23s] [animation-duration:45s]"
          />
        </Row>
        <Row>
          <Logo
            label="Node.js"
            src="/assets/nodejs.svg"
            className="[animation-delay:-55s] [animation-duration:60s]"
          />
          <Logo
            label="PostgreSQL"
            src="/assets/postgresql.svg"
            className="[animation-delay:-20s] [animation-duration:60s]"
          />
        </Row>
        <Row>
          <Logo
            label="React.js"
            src="/assets/react.svg"
            className="[animation-delay:-9s] [animation-duration:40s]"
          />
          <Logo
            label="Zapier"
            src="/assets/zapier.svg"
            className="[animation-delay:-28s] [animation-duration:40s]"
          />
        </Row>
      </div>
    </div>
  )
}
